module.exports = __webpack_public_path__ + "static/media/AideFAQ.713b1c73.pdf";